var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "6 6 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m19.829 9.91 2.25 2.25m-1.28 5.867v4.053A1.92 1.92 0 0 1 18.88 24H9.92A1.92 1.92 0 0 1 8 22.08v-8.96a1.92 1.92 0 0 1 1.92-1.92h4.053m5.856-1.29 1.44-1.441a1.6 1.6 0 0 1 2.262 2.263l-9.061 9.061a3.84 3.84 0 0 1-1.619.964l-2.291.683.683-2.291a3.84 3.84 0 0 1 .964-1.619z"
  })));
};
export default SvgEdit;